import { render, staticRenderFns } from "./HowToStartHRs.vue?vue&type=template&id=0dedf792&scoped=true&"
import script from "./HowToStartHRs.vue?vue&type=script&lang=js&"
export * from "./HowToStartHRs.vue?vue&type=script&lang=js&"
import style0 from "./HowToStartHRs.vue?vue&type=style&index=0&id=0dedf792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedf792",
  null
  
)

export default component.exports